module.exports = __webpack_public_path__ + "static/media/appstore-6a.135d6b40.png";